
import {
  debounce,
  screenCategory
} from '../library';
import { RESIZE_DEBOUNCE } from '../constants';

export default class MobileMenu {

  constructor(elementId='mobile-menu-toggle', menuSelector='.mainmenu-wrapper', direction='right') {
    this.element = document.getElementById(elementId);

    this.menu = document.querySelector(menuSelector);
    this.direction = direction;

    this.setup();
  }

  // legacy function Encore
  _eMobileMenu() {
    const OPEN = 'open';
    // const FADE = this.direction === 'left' ? 'navFadeInLeft' : 'navFadeInRight';
    // const CLOSE = this.direction === 'left' ? 'navFadeOutLeft' : 'navFadeOutRight';

    // document.documentElement.classList.add('mobile-menu-open'); // for safari

    this.element.addEventListener('click', () => {
      if(!this.element.classList.contains(OPEN)) {
        this.element.classList.add(OPEN);

        // this.menu.classList.remove(CLOSE);
        // this.menu.classList.add(OPEN);
        // this.menu.classList.add(FADE);

        document.body.classList.add('mobile-menu-open');
      } else {
        this.element.classList.remove(OPEN);
        // this.menu.classList.remove(FADE);
        // this.menu.classList.remove(OPEN);
        // this.menu.classList.add(CLOSE);

        document.body.classList.remove('mobile-menu-open');
      }
    });
  }

  setup() {
    if (!this.element || !this.menu) {
      console.warn('No element found.');
      return;
    }

    //Create mobile menu
    this._eMobileMenu();

    window.addEventListener('resize', debounce(() => {
      "use strict";
      //check if window is at 1000 pixels or larger
      if (screenCategory() === 'desktop') {
        //check if mobile menu is still open
        if (this.menu.classList.contains('open') || document.body.classList.contains('mobile-menu-open')) {
          //check the direction of the animation
          let close = this.direction === 'left' ? 'navFadeOutLeft' : 'navFadeOutRight';
          //create click event to close mobile menu
          this.element.click();
          //remove the closing animation
          // this.menu.classList.remove(close);

          document.body.classList.remove('mobile-menu-open');
        }
      }
    }, RESIZE_DEBOUNCE));
  }
}
